import React from 'react';
import Popup from 'reactjs-popup';

const PrintModal = ({ open, onClose, onConfirm, printing, printers, loading, selected, setSelected, isAdmin }) => {
  const disabled = !printing.useLocalPrint && (loading || printers.length === 0);

  return (
    <Popup open={open} onClose={onClose} modal closeOnDocumentClick className="popup-modal">
      <div className="op-modal">
        <h2 className="op-section-title">Print tickets</h2>

        {printing.useLocalPrint ? (
          <p className="op-muted">Printing to your local printer.</p>
        ) : loading ? (
          <p className="op-muted">Loading printers…</p>
        ) : printers.length === 0 ? (
          <p className="op-field op-print-error">No printers available.</p>
        ) : printers.length === 1 ? (
          <p className="op-muted">Printer 1 selected.</p>
        ) : (
          <>
            <label className="op-label" htmlFor="op-printer-select">Select a printer</label>
            <select
              id="op-printer-select"
              className="op-input"
              value={selected ? selected.value : ''}
              onChange={(e) => setSelected({ value: e.target.value, label: `Printer ${e.target.value}` })}
            >
              {printers.map((p, i) => {
                const match = p.name && p.name.match(/printer-(\d+)/);
                const n = match ? match[1] : i + 1;
                return <option key={p.name || i} value={n}>{`Printer ${n}`}</option>;
              })}
            </select>
          </>
        )}

        {!printing.useLocalPrint && isAdmin && (
          <a className="op-link" href={printing.manageUrl} target="_blank" rel="noopener noreferrer">Manage printers</a>
        )}

        <div className="op-modal-actions">
          <button type="button" className="op-btn" onClick={onClose}>Cancel</button>
          <button type="button" className="op-btn op-btn-primary" disabled={disabled} onClick={onConfirm}>Print tickets</button>
        </div>
      </div>
    </Popup>
  );
};

export default PrintModal;
